//
// Javascript for the standard system status popup on most pages
//
//  Ben Ramey
//  October 2009
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.SystemStatus = function ()
{
  this.statusPopup = $("div.system-status");

  if (this.statusPopup.length == 0) {
	  this.statusPopup = $("<div class='system-status'><img src='https://apps.hendersonengineers.com/resources/images/throbber.gif'/><span>Loading...</span></div>");
	  $('body').append(this.statusPopup);
  }

  this.statusText = $("span", this.statusPopup);
};

HEIJS.Controls.SystemStatus.prototype =
{
  //
  // Properties
  //
  statusPopup: null,
  statusText: null,
  
  systemSpin: {
	  lines: 13, // The number of lines to draw
	  length: 0, // The length of each line
	  width: 5, // The line thickness
	  radius: 14, // The radius of the inner circle
	  corners: 1, // Corner roundness (0..1)
	  rotate: 0, // The rotation offset
	  color: '#888888', // #rgb or #rrggbb
	  speed: 1.2, // Rounds per second
	  trail: 60, // Afterglow percentage
	  shadow: false, // Whether to render a shadow
	  hwaccel: false, // Whether to use hardware acceleration
	  className: 'spinner', // The CSS class to assign to the spinner
	  zIndex: 2e9, // The z-index (defaults to 2000000000)
	  top: '14px', // Top position relative to parent in px
	  left: 'auto' // Left position relative to parent in px
  },
  
   localSpin: {
	  lines: 13, // The number of lines to draw
	  length: 0, // The length of each line
	  width: 5, // The line thickness
	  radius: 14, // The radius of the inner circle
	  corners: 1, // Corner roundness (0..1)
	  rotate: 0, // The rotation offset
	  color: '#fff', // #rgb or #rrggbb
	  speed: 1.2, // Rounds per second
	  trail: 60, // Afterglow percentage
	  shadow: false, // Whether to render a shadow
	  hwaccel: false, // Whether to use hardware acceleration
	  className: 'spinner', // The CSS class to assign to the spinner
	  zIndex: 2e9, // The z-index (defaults to 2000000000)
	  top: '14px', // Top position relative to parent in px
	  left: 'auto' // Left position relative to parent in px
  },

  //
  // Methods
  //
  show: function (text, popupWidth)
  {
	var self = this;
    if (!this.statusPopup.is(".ui-dialog"))
    {
      this.statusPopup.dialog({
        autoOpen: false,
        closeOnEscape: false,
        showTitle: false,
        resizable: false,
        draggable: false,
        modal: true,
        minHeight: 130,
		width: popupWidth && !isNaN(popupWidth) && popupWidth > 50 ? popupWidth : 350,
        dialogClass: "system-status-dialog"
	  });
	  var loader = $('<div></div>').addClass('system-status-spinner').insertAfter(this.statusPopup.find('img').first());
	  this.statusPopup.find('img').remove();
	  loader.spin(self.systemSpin);
    }

    this.statusText.text(text);
    this.statusPopup.dialog("option", "modal", true);
    this.statusPopup.dialog("option", "position", { my: "center", at: "center", of: window });
    this.statusPopup.dialog("open");
	
	$(window).resize(function () {
		if (self.statusPopup && self.statusPopup.length > 0 && self.statusPopup.is(':data(ui-dialog)') && self.statusPopup.is(':visible') ) {
			self.statusPopup.dialog("option", "position", { my: "center", at: "center", of: window });
		}
	});
  },

  showDelayed: function (text, showAfterTimeout, popupWidth)
  {
    var obj = new Object();
    var self = this;
    obj.timeout = window.setTimeout(function ()
    {
      HEIJS.page.systemStatus.show(text, popupWidth);
      obj.timeout = null;
    },
	  showAfterTimeout);
    obj.remove = function ()
    {
      if (this.timeout)
      {
        window.clearTimeout(this.timeout);
      }
      if (self.statusPopup.is(':data(ui-dialog)') && self.statusPopup.dialog("isOpen"))
      {
        HEIJS.page.systemStatus.hide();
      }
    };
    return obj;
  },

  showDelayedLocal: function (text, container, showAfterTimeout, popupWidth)
  {
    var obj = new Object();
    obj.timeout = window.setTimeout(function ()
    {
      obj.localPopup = HEIJS.page.systemStatus.showLocal(text, container, false, popupWidth);
      obj.timeout = null;
    },
	  showAfterTimeout);
    obj.remove = function ()
    {
      if (this.timeout)
      {
        window.clearTimeout(this.timeout);
      }
      if (this.localPopup)
      {
        this.localPopup.remove();
      }
    };
    return obj;
  },

  showLocal: function (text, container, dontOpen, popupWidth)
  {
    var self = this;
	if (!container || container.length < 1) {
	  container = $("body");
	}
    if (typeof (container[0]._localPopup) != "undefined"
        && container[0]._localPopup.is(":visible"))
    {
      return container[0]._localPopup;
    }

    dontOpen = dontOpen || false;
    var localPopup = this.statusPopup.clone();
    var localText = $("span", localPopup);

    localText.text(text);
    localPopup.attr("class", "local-status");
    localPopup.dialog({
      autoOpen: false,
      showTitle: false,
      resizable: false,
      draggable: false,
      width: popupWidth && !isNaN(popupWidth) && popupWidth > 50 ? popupWidth : 200,
      height: 120,
      minHeight: 120,
      dialogClass: "local-status-dialog"
    });
	var loader = $('<div></div>').addClass('system-status-spinner').insertAfter(localPopup.find('img').first());
	localPopup.find('img').remove();
	loader.spin(self.localSpin);

	localPopup.dialog("option", "position", { my: "center", at: "center", of: container });	
    if (!dontOpen)
    {
      localPopup.dialog("open");
    }
	
	$(window).resize(function () {
		if (localPopup && localPopup.length > 0 && localPopup.is(':data(ui-dialog)') && localPopup.is(':visible') && container && container.length > 0) {
			localPopup.dialog("option", "position", { my: "center", at: "center", of: container });
		}
	});

    // the caller is responsible for closing and disposing of 
    // the local popup clone
    container[0]._localPopup = localPopup;
    return localPopup;
  },

  hide: function ()
  {
	if (this.statusPopup) {
		if (this.statusPopup.is(':data(ui-dialog)')) {
			this.statusPopup.dialog("close");
		} 
	}
  }
};

$(document).ready(function ()
{
  HEIJS.page.systemStatus = new HEIJS.Controls.SystemStatus();
});